<ul class="share-buttons__list">
    <li *ngFor="let item of items" class="share-buttons__item share-buttons__item--type--{{ item.type }}"
        [class.share-buttons__item--without-label]="!(item.label && showLabels)">

        <button *ngIf="item.type === 'link'" type="button" class="share-buttons__button"
                [attr.title]="linkLabel" appClick (click)="shareLink()">
            <ng-container *ngIf="showIcons">
                <svg *ngIf="copied" class="share-buttons__item-icon share-buttons__item-icon--stroke" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <polyline points="20 6 9 17 4 12"/>
                </svg>
                <svg *ngIf="!copied && canShareNatively" class="share-buttons__item-icon share-buttons__item-icon--stroke" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/>
                    <polyline points="16 6 12 2 8 6"/>
                    <line x1="12" y1="2" x2="12" y2="15"/>
                </svg>
                <svg *ngIf="!copied && !canShareNatively" class="share-buttons__item-icon share-buttons__item-icon--stroke" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
                </svg>
            </ng-container>
            <span class="share-buttons__item-label" [class.sr-only]="!showLabels" aria-live="polite">{{ linkLabel }}</span>
        </button>

        <a *ngIf="item.type !== 'link'" class="share-buttons__button" [attr.href]="item.url" target="_blank" rel="noopener noreferrer"
           [attr.title]="item.title" [attr.aria-label]="item.title" appClick>
            <ng-container *ngIf="item.icon && showIcons">
                <!-- The X mark is drawn here, not taken from sprite.svg: the sprite is served cached
                     for a year under the same url, so a symbol added to it would not reach returning
                     visitors. -->
                <svg *ngIf="item.icon === 'x'" class="share-buttons__item-icon" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"/>
                </svg>
                <app-icon *ngIf="item.icon !== 'x'" [name]="item.icon" size="16" class="share-buttons__item-icon"></app-icon>
            </ng-container>
            <span *ngIf="item.label && showLabels" class="share-buttons__item-label">{{ item.label }}</span>
        </a>
    </li>
</ul>
